import InfoButton from './InfoButton';
import OptionsStatus from './OptionsStatus';
import {
  SKILL_LABELS,
  formatLabel,
  type LoadState
} from './workflowShared';

interface SkillsStepProps {
  loadState: LoadState;
  loadError: string;
  availableSkills: string[];
  selectedSkills: Set<string>;
  onRetryLoadOptions: () => void;
  onSelectAllSkills: () => void;
  onShowSkillInfo: () => void;
  onToggleSkill: (skill: string) => void;
}

function SkillsStep({
  loadState,
  loadError,
  availableSkills,
  selectedSkills,
  onRetryLoadOptions,
  onSelectAllSkills,
  onShowSkillInfo,
  onToggleSkill
}: SkillsStepProps) {
  return (
    <>
      <div className="step-heading split-heading">
        <div>
          <div className="skills-title-row">
            <h1>Select skill packs</h1>
            <InfoButton
              label="Show skill information"
              title="About Skills"
              onClick={onShowSkillInfo}
            />
          </div>
          <p>Skills are loaded from the backend and sent with the scan request.</p>
        </div>

        {selectedSkills.size < availableSkills.length && (
          <button className="inline-action" type="button" onClick={onSelectAllSkills}>
            Select all
          </button>
        )}
      </div>

      <OptionsStatus loadState={loadState} loadError={loadError} onRetry={onRetryLoadOptions} />

      {loadState === 'ready' && (
        <div className="skill-list">
          {availableSkills.map((skill) => {
            const isSelected = selectedSkills.has(skill);

            return (
              <button
                aria-pressed={isSelected}
                className={`skill-chip ${isSelected ? 'selected' : ''}`}
                key={skill}
                type="button"
                onClick={() => onToggleSkill(skill)}
              >
                <span className="checkbox-mark" aria-hidden="true" />
                <span>{formatLabel(skill, SKILL_LABELS)}</span>
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}

export default SkillsStep;
